module.exports = __webpack_public_path__ + "img/link.5e920375.svg";